/* eslint-disable import/prefer-default-export */
const API_TIMEOUT = 2000;

export {
  API_TIMEOUT
};
